<template>
  <img :class="['handshake-image', { 'is-wide': isWide }]" :src="imageUrl" />
</template>

<script lang="ts" setup>
import { gambits } from '@/core/gambits';
import { computed } from 'vue';

export interface HandshakeImageProps {
  blobHash: string;
  isWide?: boolean;
}

const props = defineProps<HandshakeImageProps>();

const imageUrl = computed(() => {
  return gambits.imageService.getImageSrc(props.blobHash, 288 * 2);
});
</script>

<style lang="scss" scoped>
@use '@/ui/css/mixins' as *;
.handshake-image {
  flex: none;
  width: calc(50% - var(--spacing-l) / 2);
  height: auto;
  aspect-ratio: 1;
  object-fit: cover;
  border: 1px solid transparent;
  cursor: pointer;
}

.handshake-image.is-wide {
  width: 100%;
  aspect-ratio: 4 / 3;
}
@include hover-capable {
  .handshake-image:hover {
    border: 1px solid var(--color-white-100);
  }
}
</style>
